import { jsx as _jsx } from "react/jsx-runtime";
import { Trans, useTranslation } from "react-i18next";
export const AlreadyAddedProviderRefreshCopy = ({ providerName, addedDate, bold, needsLogin }) => {
    const { t } = useTranslation(["patients"]);
    if (addedDate) {
        return (_jsx(Trans, { t: t, i18nKey: needsLogin
                ? "<b>{{ providerName }}</b> was already added on {{ addedDate }}. Log in to bring in your latest data, or keep what you have."
                : "<b>{{ providerName }}</b> was already added on {{ addedDate }}. Refresh to bring in your latest data, or keep what you have.", components: { b: bold }, values: { providerName, addedDate } }));
    }
    return (_jsx(Trans, { t: t, i18nKey: needsLogin
            ? "<b>{{ providerName }}</b> was already added. Log in to bring in your latest data, or keep what you have."
            : "<b>{{ providerName }}</b> was already added. Refresh to bring in your latest data, or keep what you have.", components: { b: bold }, values: { providerName } }));
};
